import { fetchApiData } from "../../utils/apiUtils";
import { ENDPOINT } from "../../constants/api";
import { setCashData, setBranch, setPOS } from "../slices/pos.slice";

export const getBranchPos = (businessSlug, branchId) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/branch-pos?branchId=${branchId}`,
    dispatch,
    useAuth: true,
  });
  return data;
};

export const getBranchPosById =
  (businessSlug, branchId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS_BRANCH.replace(
        "{businessSlug}",
        businessSlug
      )}?branchId=${branchId}`,
      dispatch,
      useAuth: true,
    });
    dispatch(setPOS(data));
    return data;
  };

export const getBranchKitchen =
  (businessSlug, branchId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS_BRANCH_KITCHEN.replace(
        "{businessSlug}",
        businessSlug
      )}`,
      params: { branchId },
      dispatch,
      useAuth: true,
    });
    return data;
  };

export const initializePosCashLog =
  (businessSlug, data) => async (dispatch) => {
    const response = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.POS_CASH_LOG.replace(
        "{businessSlug}",
        businessSlug
      )}/initial_cash`,
      data,
      dispatch,
      useAuth: true,
    });
    return response;
  };

export const closeCashLog = (businessSlug, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS_CASH_LOG.replace(
      "{businessSlug}",
      businessSlug
    )}/close`,
    data,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const cashRemoval = (businessSlug, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS_CASH_LOG.replace(
      "{businessSlug}",
      businessSlug
    )}/cash_removal`,
    data,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const cashFloat = (businessSlug, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS_CASH_LOG.replace(
      "{businessSlug}",
      businessSlug
    )}/cash_float`,
    data,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const getInitialCash =
  (businessSlug, branchPosId) => async (dispatch) => {
    const response = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS_CASH_LOG.replace(
        "{businessSlug}",
        businessSlug
      )}/initial_cash/${branchPosId}`,
      dispatch,
      useAuth: true,
    });
    dispatch(setCashData(response));
    return response;
  };

export const getSummaryDataCancel =
  (businessSlug, branchPosId) => async (dispatch) => {
    const response = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS_CASH_LOG.replace(
        "{businessSlug}",
        businessSlug
      )}/summary_data_cancel/${branchPosId}`,
      dispatch,
      useAuth: true,
    });
    return response;
  };

export const getCashFloat = (businessSlug, branchPosId) => async (dispatch) => {
  const response = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.POS_CASH_LOG.replace(
      "{businessSlug}",
      businessSlug
    )}/cash_float/${branchPosId}`,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const getCashRemoval =
  (businessSlug, branchPosId) => async (dispatch) => {
    const response = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS_CASH_LOG.replace(
        "{businessSlug}",
        businessSlug
      )}/cash_removal/${branchPosId}`,
      dispatch,
      useAuth: true,
    });
    return response;
  };

export const getBranchInfo = (businessSlug, id) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.POS_BRANCH_INFO.replace(
      "{businessSlug}",
      businessSlug
    )}/${id}`,
    dispatch,
    useAuth: true,
  });
  dispatch(setBranch(data));
  return data;
};

export const getProductCategories =
  (businessSlug, branchPosId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `/${businessSlug}/${ENDPOINT.PRODUCT_CATEGORY}/all/list`,
      params: { branchPosId },
      dispatch,
      useAuth: true,
    });
    return data;
  };

export const getProductSubCategories =
  (businessSlug, productCategoryId, branchPosId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `/${businessSlug}/${ENDPOINT.PRODUCT_SUB_CATEGORY}/all/list`,
      params: { productCategoryId, branchPosId },
      dispatch,
      useAuth: true,
    });
    return data;
  };

export const getPaginatedBranchProducts =
  (businessSlug, branchId, params) => async (dispatch) => {
    const queryParams = {
      branchId,
      page: params.page || 1,
      // perPage: params.perPage || 10,
      perPage: 1000000,
      productCategoryId: params.productCategoryId,
      productSubCategoryId: params.productSubCategoryId,
      s: params.searchTerm,
      sortBy: params.sortBy || "created_at",
      sortOrder: params.sortOrder || "desc",
    };
    
    if (params.isRecommended || params.productCategoryId === "recommended") {
      queryParams.isRecommended = true;      
      delete queryParams.productCategoryId;
    }

    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS_BRANCH_PRODUCT.replace(
        "{businessSlug}",
        businessSlug
      )}/pagination/list`,
      params: queryParams,
      dispatch,
      useAuth: true,
    });
    return data;
  };

export const branchPosLogin = (businessSlug, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/branch-pos/login`,
    data,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const checkImportantTask = (businessSlug, data) => async (dispatch) => {
  try {
    const response = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/branch-pos/check-important-task`,
      data,
      dispatch,
      useAuth: true,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const branchKitchenLogin = (businessSlug, data) => async (dispatch) => {
  try {
    const response = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.POS_BRANCH_KITCHEN.replace(
        "{businessSlug}",
        businessSlug
      )}/login`,
      data,
      dispatch,
      useAuth: true,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const checkKitchenImportantTask =
  (businessSlug, data) => async (dispatch) => {
    const response = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.POS_BRANCH_KITCHEN.replace(
        "{businessSlug}",
        businessSlug
      )}/check-important-task`,
      data,
      dispatch,
      useAuth: true,
    });
    return response;
  };

export const createOrder = (businessSlug, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS.replace("{businessSlug}", businessSlug)}/order`,
    data,
    dispatch,
    useAuth: true,
  });

  return response;
};

export const getOrderById =
  (businessSlug, id, dismissLoading = false) =>
  async (dispatch) => {
    const response = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/order/${id}`,
      dispatch,
      useAuth: true,
      dismissLoading: dismissLoading,
    });

    return response;
  };

export const createOrderItem = (businessSlug, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${businessSlug}/order-item`,
    data,
    dispatch,
    useAuth: true,
  });

  return response;
};

export const getOrderItemById = (businessSlug, id) => async (dispatch) => {
  const response = await fetchApiData({
    method: "get",
    endpoint: `${businessSlug}/order-item/${id}`,
    dispatch,
    useAuth: true,
  });

  return response;
};

export const updateOrderItem = (businessSlug, id, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "put",
    endpoint: `${businessSlug}/order-item/${id}`,
    data,
    dispatch,
    useAuth: true,
  });

  return response;
};

export const deleteOrderItem = (businessSlug, id) => async (dispatch) => {
  const response = await fetchApiData({
    method: "delete",
    endpoint: `${businessSlug}/order-item/${id}`,
    dispatch,
    useAuth: true,
  });

  return response;
};

export const getHoldOrders =
  (businessSlug, date, branchPosSellingId) => async (dispatch) => {
    const response = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS_HOLD_ORDER.replace(
        "{businessSlug}",
        businessSlug
      )}/list?branchPosSellingId=${branchPosSellingId}`,
      params: {
        date: date,
      },
      dispatch,
      useAuth: true,
    });
    return response;
  };

export const getHoldOrderById = (businessSlug, id) => async (dispatch) => {
  const response = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.POS_HOLD_ORDER.replace(
      "{businessSlug}",
      businessSlug
    )}/${id}`,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const updateHoldOrder = (businessSlug, id, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "put",
    endpoint: `${ENDPOINT.POS_HOLD_ORDER.replace(
      "{businessSlug}",
      businessSlug
    )}/${id}`,
    data,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const createHoldOrder = (businessSlug, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS_HOLD_ORDER.replace(
      "{businessSlug}",
      businessSlug
    )}`,
    data,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const getBranchEmployees =
  (businessSlug, branchId) => async (dispatch) => {
    const response = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/user-business-group/employee`,
      params: { branchId },
      dispatch,
      useAuth: true,
    });
    return response;
  };

export const getBusinessPointSetting = (businessSlug) => async (dispatch) => {
  const response = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/business-point-setting`,
    dispatch,
    useAuth: true,
  });
  return response;
};

export const updateOrderRemark =
  (businessSlug, id, data) => async (dispatch) => {
    const response = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/order/${id}/remark`,
      data,
      dispatch,
      useAuth: true,
    });

    return response;
  };
